module.exports = __webpack_public_path__ + "static/img/6-3.5f7d3e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/6-3.png
// module id = gHQG
// module chunks = 25